import React from "react";

const Dev = () => {
  return (
    <div>
      <h1>Developed by: Leslie Paul Ajayi</h1>
    </div>
  );
};

export default Dev;
